import { createSlice } from "@reduxjs/toolkit";
import apiManagerUsersSIP from "api/manager-users-sip";
import { SLICE_NAME } from "constants/common";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data, setIsLoading) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerUsersSIP.search(data)

        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data.records,
                total: res.data.totalRecords
            }))
        } else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        setIsLoading(false)
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    searchQuery: {
        account: '',
        username: '',
        page: 0,
    },
    isRefresh: false,
}

export const managerUserSipSlice = createSlice({
    name: SLICE_NAME.MANAGER_USER_SIP,
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void(state.searchQuery = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
    }
})

export const { setTableData, setSearchQuery, toggleIsRefresh } = managerUserSipSlice.actions
export default managerUserSipSlice.reducer